import {useAgendaSearchParams} from '@/features/agenda/hooks/useAgendaSearchParams'
import {useAgendaCategoryTeam} from '@/features/agenda/hooks/useAgendaCategoryTeam'
import {useTranslation} from '@/translations/i18n'
import {StyledAgendaToolbarTitle} from './style'
import {Skeleton} from '@/components/ui/skeleton/Skeleton'
import {InputHelpText} from '@/components/ui/input-help-text/InputHelpText'
import {Flexbox} from '@/components/ui/flexbox/FlexBox'
import {useAgendaNavigation} from '@/features/agenda/hooks/useAgendaNavigation'
import {formatDate} from '@/dayjs'
import {AlertCircleIcon} from '@/components/ui/icon/Icon'

export const AgendaToolbarTeamTitle = () => {
    const {t} = useTranslation()
    const {
        params: {date}
    } = useAgendaNavigation()
    const {
        searchParams: {subjectIds}
    } = useAgendaSearchParams()
    const {patient, team, isLoading, isError} = useAgendaCategoryTeam()

    if (isLoading) {
        return (
            <StyledAgendaToolbarTitle align="center" justify="center">
                <Skeleton height={24} width={200} />
            </StyledAgendaToolbarTitle>
        )
    }

    if (isError) {
        return (
            <StyledAgendaToolbarTitle align="center" justify="center">
                <InputHelpText error={t('errors:default')} />
            </StyledAgendaToolbarTitle>
        )
    }

    if (!patient?.fullName) {
        return (
            <StyledAgendaToolbarTitle align="center" justify="center">
                {t('commons:no_results')}
            </StyledAgendaToolbarTitle>
        )
    }

    return (
        <Flexbox align="center" justify="center">
            <StyledAgendaToolbarTitle direction="column" align="center" justify="center">
                <h3>{t('agenda:equipe_name', {fullName: patient.fullName})}</h3>
                {subjectIds && subjectIds.length > 0 && (
                    <p>{t('agenda:selected_operators_count', {count: subjectIds.length})}</p>
                )}
                {team.length == 0 && (
                    <Flexbox align="center" gap={1} render="p">
                        <AlertCircleIcon size={16} />
                        {t('agenda:no_team_found_description', {date: formatDate(date, 'DD/MM/YYYY')})}
                    </Flexbox>
                )}
            </StyledAgendaToolbarTitle>
        </Flexbox>
    )
}
